import { ConfigProvider, Modal } from "antd";
import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useState,
} from "react";

type PopupProps = {
  openTrigger: React.ReactNode;
  children: React.ReactNode;
};

export type IPopup = {
  close: () => void;
  open: () => void;
};

const Popup: ForwardRefRenderFunction<IPopup, PopupProps> = (
  { openTrigger, children }: PopupProps,
  popup
) => {
  const [isVisible, setIsVisible] = useState(false);

  // Handler to open the modal
  const handleModal = () => {
    setIsVisible(!isVisible);
  };

  useImperativeHandle(popup, () => ({
    close: () => setIsVisible(false),
    open: () => setIsVisible(true),
  }));

  return (
    <ConfigProvider
      theme={{
        // Fields inside a popup sit one step above the modal surface so they
        // stay legible against it (see --rt-surface-raised in index.css).
        token: {
          colorBgContainer: "#2d2d2d",
        },
      }}
    >
      <div className="modal_open_trigger" onClick={handleModal}>
        {openTrigger}
      </div>
      <Modal open={isVisible} onCancel={handleModal} footer={null}>
        {children}
      </Modal>
    </ConfigProvider>
  );
};

export default forwardRef(Popup);
